export const formatToExcelTableShapeForStudent = (students) => {
  const exportBody = students?.map((student) => {
    return {
      "№": student.id,
      "Ism ": student.name,
      "Familiya ": student.lastName,
      "Sinf ": student.grade,
    };
  });

  return exportBody;
};

export const formatToExcelTableShapeForTeacher = (teachers) => {
  const exportBody = teachers?.map((teacher, index) => {
    return {
      "№": index + 1,
      Ism: teacher.name,
      Familiya: teacher.lastName,
      Tajriba: teacher.experience,
    };
  });

  return exportBody;
};
